// ========================================
// COMPONENTS / ProductCard.jsx
// ========================================

import React, { useState } from "react";
import styles from "./ProductCard.module.css";

export default function ProductCard({ product }) {
  const { name, price, category, subCategory, images, link } = product;
  const [imgIndex, setImgIndex] = useState(0);

  const hasImages = images && images.length > 0;
  const hasMultiple = hasImages && images.length > 1;

  const prev = (e) => {
    e.stopPropagation();
    setImgIndex((i) => (i - 1 + images.length) % images.length);
  };
  const next = (e) => {
    e.stopPropagation();
    setImgIndex((i) => (i + 1) % images.length);
  };

  return (
    <article className={styles.card}>
      {/* Image area */}
      <div className={styles.imageWrap}>
        {hasImages ? (
          <>
            <img
              key={imgIndex}
              src={`/products/${encodeURIComponent(images[imgIndex])}`}
              alt={name}
              className={styles.image}
            />
            {hasMultiple && (
              <>
                <button className={`${styles.arrow} ${styles.arrowLeft}`} onClick={prev} aria-label="Previous">‹</button>
                <button className={`${styles.arrow} ${styles.arrowRight}`} onClick={next} aria-label="Next">›</button>
                <div className={styles.imgDots}>
                  {images.map((_, i) => (
                    <span
                      key={i}
                      className={`${styles.imgDot} ${i === imgIndex ? styles.imgDotActive : ""}`}
                      onClick={(e) => { e.stopPropagation(); setImgIndex(i); }}
                    />
                  ))}
                </div>
              </>
            )}
          </>
        ) : (
          <div className={styles.placeholder}>🛍️</div>
        )}
        {subCategory && <span className={styles.badge}>{subCategory}</span>}
      </div>

      {/* Info */}
      <div className={styles.info}>
        <p className={styles.category}>{category}</p>
        <h3 className={styles.name}>{name}</h3>
        <div className={styles.footer}>
          {price > 0 ? (
            <span className={styles.price}>
              <span className={styles.priceCurrency}>AED</span>
              <span className={styles.priceAmount}>{Number(price).toFixed(0)}</span>
            </span>
          ) : (
            <span className={styles.customPrice}>Custom Price</span>
          )}
          {link ? (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.orderBtn}
            >
              Order Now
            </a>
          ) : (
            <span className={styles.comingSoon}>Coming Soon</span>
          )}
        </div>
      </div>
    </article>
  );
}
